/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Week_Other_OneInputs */

const fr_calendar_quota_week_other_one = /** @type {(inputs: Calendar_Quota_Week_Other_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 séance restante sur la semaine`)
};

/**

* @param {Calendar_Quota_Week_Other_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_week_other_one = /** @type {((inputs?: Calendar_Quota_Week_Other_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Week_Other_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_week_other_one(inputs)
});